import { TRIP_GROUPS_REDUCER_KEY } from 'store/tripGroups/actions'
import { TripGroupsState } from 'store/tripGroups/interfaces'

export const tripGroupsSelector = (state: { [TRIP_GROUPS_REDUCER_KEY]: TripGroupsState }) =>
  state[TRIP_GROUPS_REDUCER_KEY]?.data?.tripGroups

export const tripGroupsLoadingSelector = (state: { [TRIP_GROUPS_REDUCER_KEY]: TripGroupsState }) =>
  state[TRIP_GROUPS_REDUCER_KEY].isLoading
